"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    SELVEID_FRITIDSEIENDOM: function() {
        return SELVEID_FRITIDSEIENDOM;
    },
    FLERBOLIG: function() {
        return FLERBOLIG;
    },
    TILLEGGSEIENDOM: function() {
        return TILLEGGSEIENDOM;
    },
    SELVEID_BOLIG: function() {
        return SELVEID_BOLIG;
    },
    BOENHET_I_BOLIGSELSKAP: function() {
        return BOENHET_I_BOLIGSELSKAP;
    },
    TOMT: function() {
        return TOMT;
    },
    ANNEN_FAST_EIENDOM_INNENFOR_INNTEKTSGIVENDE_AKTIVITET: function() {
        return ANNEN_FAST_EIENDOM_INNENFOR_INNTEKTSGIVENDE_AKTIVITET;
    },
    ANNEN_FAST_EIENDOM_UTENFOR_INNTEKTSGIVENDE_AKTIVITET: function() {
        return ANNEN_FAST_EIENDOM_UTENFOR_INNTEKTSGIVENDE_AKTIVITET;
    },
    GAARDSBRUK: function() {
        return GAARDSBRUK;
    },
    IKKE_UTLEID_NAERINGSEIENDOM_I_NORGE: function() {
        return IKKE_UTLEID_NAERINGSEIENDOM_I_NORGE;
    },
    NAERINGSEIENDOM: function() {
        return NAERINGSEIENDOM;
    },
    EGEN_FRITAKSBEHANDLET_FRITIDSEIENDOM: function() {
        return EGEN_FRITAKSBEHANDLET_FRITIDSEIENDOM;
    },
    REGNSKAPSBEHANDLET_FRITIDSEIENDOM: function() {
        return REGNSKAPSBEHANDLET_FRITIDSEIENDOM;
    },
    EGEN_FRITAKSBEHANDLET_BOLIG: function() {
        return EGEN_FRITAKSBEHANDLET_BOLIG;
    },
    REGNSKAPSBEHANDLET_BOLIG: function() {
        return REGNSKAPSBEHANDLET_BOLIG;
    },
    BORETT: function() {
        return BORETT;
    },
    UTLEID_FLERBOLIGBYGNING_I_UTLANDET: function() {
        return UTLEID_FLERBOLIGBYGNING_I_UTLANDET;
    },
    SKOGEIENDOM_I_UTLANDET: function() {
        return SKOGEIENDOM_I_UTLANDET;
    },
    IKKE_UTLEID_NAERINGSEIENDOM_I_UTLANDET: function() {
        return IKKE_UTLEID_NAERINGSEIENDOM_I_UTLANDET;
    },
    FAST_EIENDOM_PAA_SVALBARD: function() {
        return FAST_EIENDOM_PAA_SVALBARD;
    },
    SKOGEIENDOM_I_NORGE: function() {
        return SKOGEIENDOM_I_NORGE;
    },
    ALLE_EIENDOMSTYPER: function() {
        return ALLE_EIENDOMSTYPER;
    },
    ALLE_EIENDOMSTYPER_FOR_KALKULATOR: function() {
        return ALLE_EIENDOMSTYPER_FOR_KALKULATOR;
    }
});
var SELVEID_FRITIDSEIENDOM = "selveidFritidseiendom";
var FLERBOLIG = "flerboligbygning";
var TILLEGGSEIENDOM = "skalIkkeFastsettes";
var SELVEID_BOLIG = "selveidBolig";
var BOENHET_I_BOLIGSELSKAP = "boenhetIBoligselskap";
var TOMT = "tomt";
var ANNEN_FAST_EIENDOM_INNENFOR_INNTEKTSGIVENDE_AKTIVITET = "annenFastEiendomInnenforInntektsgivendeAktivitet";
var ANNEN_FAST_EIENDOM_UTENFOR_INNTEKTSGIVENDE_AKTIVITET = "annenFastEiendomUtenforInntektsgivendeAktivitet";
var GAARDSBRUK = "gaardsbruk";
var IKKE_UTLEID_NAERINGSEIENDOM_I_NORGE = "ikkeUtleidNaeringseiendomINorge";
var NAERINGSEIENDOM = "naeringseiendom";
var EGEN_FRITAKSBEHANDLET_FRITIDSEIENDOM = "egenFritaksbehandletFritidseiendom";
var REGNSKAPSBEHANDLET_FRITIDSEIENDOM = "regnskapsbehandletFritidseiendom";
var EGEN_FRITAKSBEHANDLET_BOLIG = "egenFritaksbehandletBolig";
var REGNSKAPSBEHANDLET_BOLIG = "regnskapsbehandletBolig";
var BORETT = "borett";
var UTLEID_FLERBOLIGBYGNING_I_UTLANDET = "utleidFlerboligbygningIUtlandet";
var SKOGEIENDOM_I_UTLANDET = "skogeiendomIUtlandet";
var IKKE_UTLEID_NAERINGSEIENDOM_I_UTLANDET = "ikkeUtleidNaeringseiendomIUtlandet";
var FAST_EIENDOM_PAA_SVALBARD = "fastEiendomPaaSvalbard";
var SKOGEIENDOM_I_NORGE = "skogeiendomINorge";
var ALLE_EIENDOMSTYPER = [
    BORETT,
    EGEN_FRITAKSBEHANDLET_BOLIG,
    REGNSKAPSBEHANDLET_BOLIG,
    EGEN_FRITAKSBEHANDLET_FRITIDSEIENDOM,
    REGNSKAPSBEHANDLET_FRITIDSEIENDOM,
    TOMT,
    GAARDSBRUK,
    SKOGEIENDOM_I_UTLANDET,
    IKKE_UTLEID_NAERINGSEIENDOM_I_UTLANDET,
    ANNEN_FAST_EIENDOM_INNENFOR_INNTEKTSGIVENDE_AKTIVITET,
    ANNEN_FAST_EIENDOM_UTENFOR_INNTEKTSGIVENDE_AKTIVITET,
    FLERBOLIG,
    UTLEID_FLERBOLIGBYGNING_I_UTLANDET,
    SELVEID_BOLIG,
    SELVEID_FRITIDSEIENDOM,
    BOENHET_I_BOLIGSELSKAP,
    IKKE_UTLEID_NAERINGSEIENDOM_I_NORGE,
    NAERINGSEIENDOM,
    TILLEGGSEIENDOM,
    FAST_EIENDOM_PAA_SVALBARD
];
var ekskluder = function(verdi) {
    return function(type) {
        return type !== verdi;
    };
};
var ALLE_EIENDOMSTYPER_FOR_KALKULATOR = ALLE_EIENDOMSTYPER.filter(ekskluder(TILLEGGSEIENDOM)).filter(ekskluder(FAST_EIENDOM_PAA_SVALBARD)).filter(ekskluder(FLERBOLIG)); // denne skal implementeres senere
